export { PropertyGoo } from "./PropertyGoo";
